module.exports = __webpack_public_path__ + "static/fullSmm-c8030a5a56464d783b6e4fce43343b85.svg";